import { render } from "./RegisterTypeOfUsers.vue?vue&type=template&id=dc3e83ce"
import script from "./RegisterTypeOfUsers.vue?vue&type=script&lang=js"
export * from "./RegisterTypeOfUsers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__